import api from '../../../axiosConfig';
const pendientes = new Map();
export async function guardarAutorizacion(id, datos) {
  const key = JSON.stringify([id, datos]);
  if (!pendientes.has(key)) pendientes.set(key, crypto.randomUUID());
  try {
    const response = await api.put(`/autorizaciones/${id}`, { ...datos, operacion_id: pendientes.get(key) });
    pendientes.delete(key);
    return response;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) pendientes.delete(key);
    throw error;
  }
}
